var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.windowClass},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('report-per-branch',{attrs:{"show":true}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }